const withSessionStorage = <T>(action: (storage: Storage) => T, fallback: T): T => {
  try {
    return typeof window === 'undefined' ? fallback : action(window.sessionStorage)
  } catch (_) {
    return fallback
  }
}

export const getSessionStorageItem = (key: string): string | null => withSessionStorage((storage) => storage.getItem(key), null)

export const setSessionStorageItem = (key: string, value: string): void =>
  withSessionStorage((storage) => storage.setItem(key, value), undefined)

export const removeSessionStorageItem = (key: string): void => withSessionStorage((storage) => storage.removeItem(key), undefined)

export const clearSessionStorage = (): void => withSessionStorage((storage) => storage.clear(), undefined)
